<template>
  <div class="home">
    <UserInfo :appLogo="appLogo" :appTitle="appTitle" />
  </div>
</template>

<script>
// @ is an alias to /src
import UserInfo from '@/components/UserInfo.vue'

export default {
  props:['appLogo', 'appTitle'],
  name: 'UserInfoView',
  components: {
    UserInfo
  }
}
</script>
